import { useQuery } from "@tanstack/react-query"
import { getBackofficeClusterQuery } from "modules/backoffice/lib/clusters/getBackofficeClusterQuery"

export function useGetBackofficeClusterQuery(
  ...args: Parameters<typeof getBackofficeClusterQuery>
) {
  return useQuery(getBackofficeClusterQuery(...args))
}
